
import startApp from "../../entry";
import blockchainPage from "./blockchain.vue";

startApp(blockchainPage);
